//login
export const userLoggedInSuccessfully = 'user logged in successfully'

//access
export const userClickedOnAccessButton = 'user clicked on access button'
export const userClickedOnContactOrpheusOnAceessPage= 'user clicked contact orpheus on access page'
export const userClickedOnSecretRevealOnAceessPage='user clicked reveal api key on access page'